export default __webpack_public_path__ + "static/O0040-ca634a8c9f53f87629ae6664362cf4d2.png";